const DesignStudioHome = () => import('@/views/design-studio/design-studio-index-view');
const DesignStudioLibrary = () => import('@/views/design-studio/design-studio-library-view');
const DesignStudioEmail = () => import('@/views/design-studio/design-studio-email-view');
const DesignStudioLanding = () => import('@/views/design-studio/design-studio-landing-page-view');
const DesignStudioCollateral = () => import('@/views/design-studio/design-studio-collateral-view');
const DesignStudioDocuments = () => import('@/views/design-studio/design-studio-documents-view');
const DesignStudioJourneys = () => import('@/views/design-studio/design-studio-journeys-view');
const DesignStudioMarketingPlans = () => import('@/views/design-studio/design-studio-marketing-plans-view');
const DesignStudioSocialMedia = () => import('@/views/design-studio/design-studio-social-media-view');
const DesignStudioFiles = () => import('@/views/design-studio/design-studio-files-view');
const DesignStudioMyCreations = () => import('@/views/design-studio/design-studio-my-creations-view')

export default [
    {
        path: '/DesignStudio/Home',
        name: 'DesignStudioIndex',
        component: DesignStudioHome,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-index-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/Clients/:clientId/DesignStudio/Home',
        name: 'ParentDesignStudioIndex',
        component: DesignStudioHome,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-my-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/DesignStudio/Library',
        name: 'DesignStudioLibrary',
        component: DesignStudioLibrary,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-library-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/Clients/:clientId/DesignStudio/Library',
        name: 'ParentDesignStudioLibrary',
        component: DesignStudioLibrary,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-library-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/DesignStudio/MyCreations',
        name: 'DesignStudioMyCreations',
        component: DesignStudioMyCreations,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-my-creations',
            pageTitle: 'Design Studio',
        },
    },

    {
        path: '/Clients/:clientId/DesignStudio/MyCreations',
        name: 'ParentDesignStudioMyCreations',
        component: DesignStudioMyCreations,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-my-creations',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/DesignStudio/Email',
        name: 'DesignStudioEmail',
        component: DesignStudioEmail,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-email-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/Clients/:clientId/DesignStudio/Email',
        name: 'ParentDesignStudioEmail',
        component: DesignStudioEmail,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-email-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/DesignStudio/LandingPages',
        name: 'DesignStudioLandingPages',
        component: DesignStudioLanding,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-landing-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/Clients/:clientId/DesignStudio/LandingPages',
        name: 'ParentDesignStudioLandingPages',
        component: DesignStudioLanding,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-landing-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/DesignStudio/Collateral',
        name: 'DesignStudioCollateral',
        component: DesignStudioCollateral,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-collateral-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/Clients/:clientId/DesignStudio/Collateral',
        name: 'ParentDesignStudioCollateral',
        component: DesignStudioCollateral,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-collateral-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/DesignStudio/Documents',
        name: 'DesignStudioDocuments',
        component: DesignStudioDocuments,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-documents-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/Clients/:clientId/DesignStudio/Documents',
        name: 'ParentDesignStudioDocuments',
        component: DesignStudioDocuments,
        meta: {
            // type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-documents-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/DesignStudio/Journeys',
        name: 'DesignStudioJourneys',
        component: DesignStudioJourneys,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-journeys-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/Clients/:clientId/DesignStudio/Journeys',
        name: 'ParentDesignStudioJourneys',
        component: DesignStudioJourneys,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-journeys-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/DesignStudio/MarketingPlans',
        name: 'DesignStudioMarketingPlans',
        component: DesignStudioMarketingPlans,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-marketing-plans-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/Clients/:clientId/DesignStudio/MarketingPlans',
        name: 'ParentDesignStudioMarketingPlans',
        component: DesignStudioMarketingPlans,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-marketing-plans-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/DesignStudio/SocialMedia',
        name: 'DesignStudioSocialMedia',
        component: DesignStudioSocialMedia,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-social-media-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/Clients/:clientId/DesignStudio/SocialMedia',
        name: 'ParentDesignStudioSocialMedia',
        component: DesignStudioSocialMedia,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-social-media-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/DesignStudio/Files',
        name: 'DesignStudioFiles',
        component: DesignStudioFiles,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-files-page',
            pageTitle: 'Design Studio',
        },
    },
    {
        path: '/Clients/:clientId/DesignStudio/Files',
        name: 'ParentDesignStudioFiles',
        component: DesignStudioFiles,
        meta: {
            type: 'client',
            subtype: 'design-studio',
            isUiShown: true,
            pageClass: 'design-studio-files-page',
            pageTitle: 'Design Studio',
        },
    }
];